export default __webpack_public_path__ + "static/media/logo.8f56626c.jpg";